function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "order-failure_inline_svg__nycxcqvt6a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.600000 0 0 0 0 0.600000 0 0 0 0 0.600000 0 0 0 1.000000 0"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero",
  filter: "url(#order-failure_inline_svg__nycxcqvt6a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 0C8.952 0 0 8.952 0 20s8.952 20 20 20 20-8.952 20-20S31.048 0 20 0zm9.806 25.25a.965.965 0 010 1.371l-3.193 3.185a.965.965 0 01-1.371 0L20 24.516l-5.25 5.29a.965.965 0 01-1.371 0l-3.185-3.193a.965.965 0 010-1.371L15.484 20l-5.29-5.25a.965.965 0 010-1.371l3.193-3.194a.969.969 0 011.371 0L20 15.484l5.25-5.29a.965.965 0 011.371 0l3.194 3.193a.969.969 0 010 1.371L24.516 20l5.29 5.25z",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.806 25.25a.965.965 0 010 1.371l-3.193 3.185a.965.965 0 01-1.371 0L20 24.516l-5.25 5.29a.965.965 0 01-1.371 0l-3.185-3.193a.965.965 0 010-1.371L15.484 20l-5.29-5.25a.965.965 0 010-1.371l3.193-3.194a.969.969 0 011.371 0L20 15.484l5.25-5.29a.965.965 0 011.371 0l3.194 3.193a.969.969 0 010 1.371L24.516 20l5.29 5.25z"
}));

function SvgOrderFailureinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2);
}

export default SvgOrderFailureinline;